import { useQuery } from '@tanstack/react-query';
import type { CompetitorFinding, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useCompetitorFindings(runId: string | undefined) {
  return useQuery({
    queryKey: ['competitor-findings', runId],
    queryFn: () =>
      apiGet<CursorPage<CompetitorFinding>>(`/v1/competitor-runs/${runId}/findings`),
    enabled: !!runId,
    refetchInterval: 10_000,
  });
}
